<div class="component-container">
  <form [formGroup]="form" class="d-flex flex-column gap-3 w-100">
    <div class="d-flex flex-column gap-2 form-group w-100">
      <label>Nom du document *</label>
      <input type="text" class="form-control" formControlName="title">
    </div>
    <!--
    <div class="d-flex flex-column gap-2 form-group w-100">
      <label>Description</label>
      <textarea formControlName="description"></textarea>
    </div>
    -->
    <div class="d-flex flex-column gap-2 form-group w-100" id="uploader">
      <label>Fichier *</label>
      <div class="list">
        <div class="content">
          <div class="item d-flex flex-row align-items-center justify-content-between" *ngIf="form.value.file?.name">
            <span class="name">{{ form.value.file.name }}</span>
            <div class="d-flex flex-row align-items-center">
              <div class="d-flex flex-row align-items-center gap-3 me-3">
                <label>A compléter</label>
                <app-toggle formControlName="toBeCompleted" [ngModelOptions]="{standalone: true}"></app-toggle>
              </div>
              <button class="button m icon transparent" (click)="removeFile()"><i class="ti ti-trash"></i></button>
            </div>
          </div>
        </div>
      </div>
      <app-file-uploader (onFilesAdded)="addFile($event)"></app-file-uploader>
    </div>
    <!-- <div class="d-flex flex-row align-items-center justify-content-between gap-3" *ngIf="enableLibraryToggle">
      <label *ngIf="user.accessType === 'mutuelle'">Ajouter ce document à <span class="special-color">La bibliothèque de
          la mutuelle</span></label>
      <label *ngIf="user.accessType === 'enterprise'">Ajouter ce document à <span class="special-color">La bibliothèque
          de l'entreprise</span></label>
      <app-toggle formControlName="addToLibrary"></app-toggle>
    </div> -->
  </form>
</div>